import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { environment } from "../../../environments/environment";
import { MzModalService } from "ng2-materialize";
import { SprintService } from "../../services/sprint/sprint.service";
import { ActivatedRoute } from "@angular/router";
import { Sprint } from "../../interfaces/sprint";
import { EditSprintDialogComponent } from "../edit-sprint-dialog/edit-sprint-dialog.component";
import { FeatureService } from "../../services/feature/feature.service";
import { ConfirmSyncComponent } from "../confirm-sync/confirm-sync.component";
import { ModalSprintStartComponent } from "../modal-sprint-start/modal-sprint-start.component";
import { JiraService } from "../../services/jira/jira.service";
import { JiraSyncProgressComponent } from "../jira-sync-progress/jira-sync-progress.component";
import { ExportService } from "../../services/export/export.service";
import { saveAs } from "file-saver";
import { SortablejsOptions } from "angular-sortablejs";
import { Feature } from "../../interfaces/feature";
import { chartColorScheme } from "../../utils/chartColortScheme";

@Component({
  selector: "app-sprints",
  templateUrl: "./sprints.component.html",
  styleUrls: ["./sprints.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SprintsComponent implements OnInit {
  env: any = environment;
  loading = true;
  project: Project;
  backlog: Sprint;
  runningSprint: Sprint;
  runningSprintArray: Sprint[];
  plannedSprints: Sprint[];
  closedSprints: Sprint[];
  isJiraProject: boolean;
  sprints: Sprint[];
  features: Feature[];
  sortedFeatures: Feature[]; //features sorted by name

  // options for combo chart

  bars: any[] = [];
  lines: any[] = [];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabelBar = "User Stories";
  showYAxisLabel = true;
  yAxisLabelBar = "Story Points Einigung";
  colorScheme = chartColorScheme;
  legendTitle = "Legende";
  legendPosition = "below";

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = "Streuung";

  schemeType = "ordinal";

  showBars: boolean = true;
  checkboxes: boolean[] = [false, false, false, false]; //defines wich spread checkboxes are selected by default
  sprintCheckboxes: boolean[] = [true, true, true, false];
  checkboxesDisabled: boolean[] = [false, false, false, false];
  radio: number = 1; // 1 = average; 2 = median; 3 = definedValue
  m = 0; //slope of trendline
  b = 0; // beginning of trendline

  yMax = 100;

  chartWidth = "100%";

  barColor = {
    group: "ordinal",
    domain: ["#d6e098"],
  };
  lineColors = {
    group: "ordinal",
    domain: ["#d6e098", "#90535d", "#686a6e", "#497c88"],
  };

  hasEstimatedFeatures = false;

  agreementAverage: number = 0;
  agreementMedian: number = 0;
  agreementValues: number[] = [];

  runningDropzoneActive: boolean;
  plannedDropzoneActive: boolean;
  closedDropzoneActive: boolean;

  plannedSprintsOptions: SortablejsOptions = {
    group: {
      name: "groupPlanned",
      put: ["groupClosed", "groupRunning"],
    },
    sort: true,
    ghostClass: "ghostDrag",
    onStart: (_) => {
      this.runningDropzoneActive = this.runningSprintArray.length === 0;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
    },
    onEnd: (_) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
    },
    onAdd: async (event) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
      const result = await (<ModalSprintStartComponent>this.modalService.open(
        ModalSprintStartComponent,
        {
          action: "plan",
          isJiraProject: this.isJiraProject,
        }
      ).instance).result
        .asObservable()
        .first()
        .toPromise();
      if (result === true && !this.isJiraProject) {
        for (let i = 0; i < this.plannedSprints.length; i++) {
          if (this.plannedSprints[i].state !== "future") {
            this.plannedSprints[i].state = "future";
            this.plannedSprints[i].completeDate = null;
          }
          this.plannedSprints[i].index = i;
          this.sprintService.saveSprint(this.plannedSprints[i]);
        }
      }
      await this.loadSprints();
      this.changeDetector.detectChanges();
    },
    onSort: async (event) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
      for (let i = 0; i < this.plannedSprints.length; i++) {
        this.plannedSprints[i].index = i;
        this.sprintService.saveSprint(this.plannedSprints[i]);
      }
    },
  };
  closedSprintsOptions: SortablejsOptions = {
    group: {
      name: "groupClosed",
      put: ["groupRunning"],
    },
    sort: false,
    ghostClass: "ghostDrag",
    onStart: (_) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = true;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
    },
    onEnd: (_) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
    },
    onAdd: async (event) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
      const result = await (<ModalSprintStartComponent>this.modalService.open(
        ModalSprintStartComponent,
        {
          action: "stop",
          isJiraProject: this.isJiraProject,
        }
      ).instance).result
        .asObservable()
        .first()
        .toPromise();
      if (result === true && !this.isJiraProject) {
        for (const sprint of this.closedSprints) {
          if (sprint.state !== "closed") {
            sprint.state = "closed";
            sprint.completeDate = new Date();
            sprint.index = 0;
            this.sprintService.saveSprint(sprint);
            break;
          } else {
            sprint.index++;
          }
        }
      }
      await this.loadSprints();
      this.changeDetector.detectChanges();
    },
  };
  runningSprintOptions: SortablejsOptions = {
    group: {
      name: "groupRunning",
      put: (to, from) => {
        return (
          from.options.group.name === "groupPlanned" &&
          this.runningSprintArray.length === 0
        );
      },
    },
    sort: false,
    ghostClass: "ghostDrag",
    onStart: (_) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = true;
      this.closedDropzoneActive = true;
      this.changeDetector.detectChanges();
    },
    onEnd: (_) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
    },
    onAdd: async (event) => {
      this.runningDropzoneActive = false;
      this.plannedDropzoneActive = false;
      this.closedDropzoneActive = false;
      this.changeDetector.detectChanges();
      const result = await (<ModalSprintStartComponent>this.modalService.open(
        ModalSprintStartComponent,
        {
          action: "start",
          isJiraProject: this.isJiraProject,
        }
      ).instance).result
        .asObservable()
        .first()
        .toPromise();
      if (result === true && !this.isJiraProject) {
        for (const sprint of this.runningSprintArray) {
          if (sprint.state !== "active") {
            sprint.state = "active";
            sprint.completeDate = null;
            this.sprintService.saveSprint(sprint);
            break;
          }
        }
      }
      await this.loadSprints();
      this.changeDetector.detectChanges();
    },
  };

  @ViewChild("EditSprintModal") EditSprintModal: EditSprintDialogComponent;
  @ViewChild("JiraSyncProgressModal")
  JiraSyncProgressModal: JiraSyncProgressComponent;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private projectService: ProjectService,
    private exportService: ExportService,
    private sprintService: SprintService,
    private featureService: FeatureService,
    private route: ActivatedRoute,
    public modalService: MzModalService
  ) {}

  ngOnInit() {
    /**
     * get all epics and feature by given projectID
     */
    this.route.params.subscribe(async (params: { id: string }) => {
      this.project = await this.projectService.getProjectByShortId(params.id);
      if (this.project.issueTrackerLink.issueTracker) {
        this.isJiraProject = true;
        this.closedSprintsOptions.disabled = true;
        this.plannedSprintsOptions.disabled = true;
        this.runningSprintOptions.disabled = true;
      } else {
        this.isJiraProject = false;
      }
      this.showBars =
        this.project.showBars.sprints !== undefined
          ? this.project.showBars.sprints
          : this.showBars;
      this.checkboxes =
        this.project.spreadCheckboxes.sprints || this.checkboxes;
      this.radio = this.project.radio.sprints || this.radio;
      this.sprintCheckboxes =
        this.project.sprintCheckboxes.length > 0
          ? this.project.sprintCheckboxes
          : this.sprintCheckboxes;
      await this.loadSprints();
    });
  }

  async loadSprints() {
    this.loading = true;
    this.features = await this.featureService.getFeaturesByProjectId(
      this.project._id
    );
    this.sprints = await this.sprintService.getSprintsByProjectId(
      this.project._id
    );
    this.sprints.forEach((x) => {
      x["features"] = this.features.filter((y) => x._id == y.sprint);
    });
    this.features.forEach((feature) => {
      if (
        feature.effort ||
        (feature.estimations.length > 0 &&
          feature.estimations[feature.estimations.length - 1].average &&
          feature.estimations[feature.estimations.length - 1].median)
      )
        this.hasEstimatedFeatures = true;
      return;
    });
    this.backlog =
      this.sprints.filter((x) => x.state === "backlog").length > 0
        ? this.sprints.filter((x) => x.state === "backlog")[0]
        : null;
    this.runningSprint =
      this.sprints.filter((x) => x.state === "active").length > 0
        ? this.sprints.filter((x) => x.state === "active")[0]
        : null;
    this.plannedSprints = this.sprints
      .filter((x) => x.state === "future")
      .sort((x, y) => x.index - y.index);
    this.closedSprints = this.sprints
      .filter((x) => x.state === "closed")
      .sort(
        (x, y) =>
          new Date(y.completeDate).getTime() -
          new Date(x.completeDate).getTime()
      );
    this.runningSprintArray = !this.runningSprint ? [] : [this.runningSprint];
    this.checkboxChanged();
    this.loading = false;
  }

  async openNewSprintDialog() {
    this.EditSprintModal.modalComponent.open();
  }

  async syncProject() {
    const result = await (<ConfirmSyncComponent>(
      this.modalService.open(ConfirmSyncComponent).instance
    )).result
      .asObservable()
      .first()
      .toPromise();
    if (result === true) {
      await this.JiraSyncProgressModal.sync(this.project.shortId);
      await this.loadSprints();
      this.project.unsyncedChanges = false;
    }
  }

  async exportClicked() {
    const blob = await this.exportService.exportFeatures(this.project._id);
    saveAs(
      blob,
      this.project.name.replace(/[\\/:"*?<>|]+/, "") + " Items.xlsx"
    );
  }

  async createSprintClicked(newSprint) {
    newSprint.state = "future";
    const createdSprint = await this.sprintService.createSprint(newSprint);
    await this.loadSprints();
    if (this.project.issueTrackerLink.issueTracker) {
      this.project.unsyncedChanges = true;
    }
  }

  /*
Generates the Dataobjects for the combo chart
*/
  createChartDataObjects(sprints: Sprint[]) {
    this.bars = [];
    this.lines = [];

    if (sprints.length > 0) {
      var tempAgreementValue = [];
      var tempAgreementAverageValue = [];
      var tempAgreementMedianValue = [];
      var tempTrendValue = [];
      var countItems = 0;
      sprints.forEach((sprint) => {
        if (sprint["features"].length > 0) {
          sprint["features"].forEach((feature, index) => {
            if (feature.effort || feature.estimations.length > 0) {
              countItems++;
              if (
                feature.estimations[feature.estimations.length - 1] ===
                undefined
              ) {
                var barValues = [
                  feature.effort,
                  feature.effort,
                  feature.effort,
                ];
              } else {
                var barValues = [
                  feature.estimations[feature.estimations.length - 1].average ||
                    0,
                  feature.estimations[feature.estimations.length - 1].median ||
                    0,
                  feature.effort || 0,
                ];
              }
              if (this.showBars) {
                var tempBarValue = {
                  name: feature.agirId,
                  value: barValues[this.radio - 1],
                };
                this.bars.push(tempBarValue);
              } else {
                var tempBarValue2 = {
                  name: feature.agirId,
                  value: 0,
                };
                this.bars.push(tempBarValue2);
              }

              if (this.checkboxes[0]) {
                let tempLineSeriesValue = {
                  name: feature.agirId,
                  value:
                    feature.estimations[feature.estimations.length - 1] ===
                    undefined
                      ? 0
                      : feature.estimations[feature.estimations.length - 1]
                          .agreement,
                };
                tempAgreementValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[1]) {
                let tempLineSeriesValue = {
                  name: feature.agirId,
                  value: this.agreementAverage,
                };
                tempAgreementAverageValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[2]) {
                let tempLineSeriesValue = {
                  name: feature.agirId,
                  value: this.agreementMedian,
                };
                tempAgreementMedianValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[3]) {
                let tempLineSeriesValue = {
                  name: feature.agirId,
                  value: this.m * (tempTrendValue.length + 1) + this.b,
                };
                // console.log("m= " + this.m);
                // console.log("b= " + this.b);
                // console.log("x= " + (tempTrendValue.length + 1));
                // console.log(tempLineSeriesValue);

                tempTrendValue.push(tempLineSeriesValue);
              }
            }
          });
        }
      });

      if (countItems > 39) {
        this.chartWidth = countItems * 30 + 500 + "px";
      } else {
        this.chartWidth = "inherit";
      }

      if (tempAgreementValue.length > 0) {
        this.lines.push({
          name: "Streuung",
          series: tempAgreementValue,
        });
      }
      if (tempAgreementAverageValue.length > 0) {
        this.lines.push({
          name: "Streuung Mittelwert",
          series: tempAgreementAverageValue,
        });
      }
      if (tempAgreementMedianValue.length > 0) {
        this.lines.push({
          name: "Streuung Median",
          series: tempAgreementMedianValue,
        });
      }
      if (tempTrendValue.length > 0) {
        this.lines.push({
          name: "Streuung Trend",
          series: tempTrendValue,
        });
      }
    }
    window.dispatchEvent(new Event("resize"));
  }
  /**
   * calculates the median and average from agreements
   */
  calcAgreement(sprints: Sprint[]) {
    this.agreementAverage = 0;
    this.agreementValues = [];
    if (sprints.length > 0) {
      sprints.forEach((sprint) => {
        if (sprint["features"].length > 0) {
          sprint["features"].forEach((feature, index) => {
            if (feature.estimations.length > 0) {
              //&& variant.estimations[variant.estimations.length - 1].agreement
              this.agreementValues.push(
                feature.estimations[feature.estimations.length - 1].agreement ||
                  0.0
              );
              this.agreementAverage +=
                feature.estimations[feature.estimations.length - 1].agreement ||
                0.0;
            }
          });
        }
      });

      if (this.agreementAverage > 0) {
        this.agreementAverage /= this.agreementValues.length;

        if (this.agreementValues.length % 2 === 1) {
          this.agreementMedian = this.agreementValues[
            Math.ceil(this.agreementValues.length / 2) - 1
          ];
        } else {
          this.agreementMedian =
            (this.agreementValues[this.agreementValues.length / 2 - 1] +
              this.agreementValues[this.agreementValues.length / 2]) /
            2;
        }
      }
    }
  }

  /**
   * calculates the trendline for agreement
   */
  calcRegression() {
    this.m = 0;
    this.b = 0;
    var featureAverage = 0;
    if (this.agreementValues.length > 0) {
      this.agreementValues.forEach((value, index) => {
        featureAverage += index + 1;
      });
      featureAverage /= this.agreementValues.length;
    }
    var sumA = 0;
    var sumB = 0;
    if (this.agreementValues.length > 0) {
      this.agreementValues.forEach((value, index) => {
        sumA += (index + 1 - featureAverage) * (value - this.agreementAverage);
        sumB += Math.pow(index + 1 - featureAverage, 2);
      });
      this.m = sumA / sumB;
      // console.log(tempSteigung);
      this.b = this.agreementAverage - this.m * featureAverage;
    }
  }

  radioChanged() {
    var barLabels = [
      "Story Points Mittelwert",
      "Story Points Median",
      "Story Points Einigung",
    ];
    this.yAxisLabelBar = barLabels[this.radio - 1];

    this.checkboxChanged();
  }

  checkboxChanged() {
    this.project.radio.sprints = this.radio;
    this.project.showBars.sprints = this.showBars;
    this.project.spreadCheckboxes.sprints = this.checkboxes;
    this.project.sprintCheckboxes = this.sprintCheckboxes;
    // this.projectService.updateProject(this.project);

    var displayedSprints: Sprint[] = [];
    this.sprintCheckboxes.forEach((checkbox, index) => {
      if (checkbox) {
        switch (index) {
          case 0: //backlog
            if (this.backlog) displayedSprints.push(this.backlog);
            break;
          case 1: //active sprint
            if (this.runningSprint) displayedSprints.push(this.runningSprint);
            break;
          case 2: //planned sprints
            if (this.plannedSprints) {
              this.plannedSprints.forEach((sprint) => {
                displayedSprints.push(sprint);
              });
            }
            break;
          case 3: //closed sprints
            if (this.closedSprints) {
              this.closedSprints.forEach((sprint) => {
                displayedSprints.push(sprint);
              });
            }
            break;
          default:
            break;
        }
      }
    });

    var count = 0;
    var tempIndex = -1;
    this.checkboxes.forEach((value, index) => {
      if (value === true) {
        count++;
        tempIndex = index;
      }
    });
    if (count === 0 && !this.showBars) {
      this.bars = [];
      this.lines = [];
    } else {
      this.calcAgreement(displayedSprints);
      this.calcRegression();
      this.createChartDataObjects(displayedSprints);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/sprints/sprints.component.ts